import { formatCents, unitPriceCents, packageSavingCents } from '@azoya-spa/contracts'

// Un montant « non proposé » (null) n'est jamais affiché : les forfaits
// d'épilation, qui n'ont pas de tarif adhérent, montrent simplement leur prix.
// Le visiteur ne voit plus jamais « Indisponible ».
function Principal({ children }) {
  return <span className="services-price-main">{children}</span>
}

function Secondaire({ children }) {
  return <span className="services-price-aside">{children}</span>
}

export function ServicePrice({ amounts }) {
  switch (amounts.type) {
    case 'pass': {
      const { avecPass, sansPass } = amounts
      if (avecPass === null) return <Principal>{formatCents(sansPass)}</Principal>
      if (sansPass === null) return <Principal>{formatCents(avecPass)} avec le pass</Principal>
      return (
        <>
          <Principal>{formatCents(avecPass)} avec le pass</Principal>
          <Secondaire>{formatCents(sansPass)} sans</Secondaire>
        </>
      )
    }

    case 'duo': {
      const { seuleAvecPass, seuleSansPass, aDeux } = amounts
      const seule = seuleAvecPass ?? seuleSansPass
      return (
        <>
          <Principal>
            seule {formatCents(seule)}
            {seuleAvecPass !== null && ' avec le pass'}
          </Principal>
          {seuleAvecPass !== null && seuleSansPass !== null && (
            <Secondaire>{formatCents(seuleSansPass)} sans</Secondaire>
          )}
          {aDeux !== null && <Principal>à deux {formatCents(aDeux)}</Principal>}
        </>
      )
    }

    case 'quantite': {
      const unitaire = unitPriceCents(amounts)
      return amounts.unite === 'personne' ? (
        <>
          <Principal>{formatCents(amounts.total)} la séance</Principal>
          <Secondaire>soit {formatCents(unitaire)} par personne</Secondaire>
        </>
      ) : (
        <>
          <Principal>{formatCents(amounts.total)}</Principal>
          <Secondaire>soit {formatCents(unitaire)} la séance</Secondaire>
        </>
      )
    }

    case 'forfait': {
      const economie = packageSavingCents(amounts)
      return (
        <>
          <Principal>{formatCents(amounts.prixSeance)} la séance</Principal>
          <Principal>
            {formatCents(amounts.prixForfait)} les {amounts.nombreSeances} séances
          </Principal>
          <Secondaire>{formatCents(economie)} d’économie</Secondaire>
        </>
      )
    }

    // `case 'unique':` explicite plutôt que `default:` : un sixième type de
    // tarif futur, non prévu par `Amounts`, tomberait ici avec un `amounts`
    // sans `.prix` ni `.unite` et rendrait « NaN € » au visiteur au lieu
    // d'échouer bruyamment (défaut mineur, revue finale).
    case 'unique': {
      const suffixe =
        amounts.unite === 'personne' ? ' par personne' : amounts.unite === 'seance' ? ' la séance' : ''
      return <Principal>{formatCents(amounts.prix)}{suffixe}</Principal>
    }

    default:
      return null
  }
}
